<template>
  <van-popup v-model="openModal" @click-overlay="maskClicked">
    <div class="wrapper">
      <div class="header"><span>{{project.item}}</span><i class="icon icon-close" @click.stop="maskClicked()"></i></div>
      <div class="main-box">

        <div class="item" v-if="project.star">
          <div class="assertive">推荐等级</div>
          <p class="projectStar " :class="'star-'+ project.star"></p>
          <!--<div class="projectStar " :class="'star-'+ project.star"></div>-->
        </div>
        <div class="item" v-show="project.counditionInfoList && project.counditionInfoList.length">
          <div class="assertive">推荐理由</div>
          <p> <span v-for="(item,index) in project.counditionInfoList" class="counditionInfo">{{item.name}} {{project.counditionInfoList.length-1 > index ? '&nbsp;&nbsp;&nbsp; ': ''}}</span></p>
        </div>
        <!--<div class="item" v-if="project.base===1">-->
        <!--<div>基础项目</div>-->
        <!--<p>该项目是您所处年龄段人群最基本的体检项目</p>-->
        <!--</div>-->
        <div class="item">
          <div>检查意义</div>
          <p>{{project.inspectionSignificance || '无'}}</p>
        </div>
      </div>

    </div>
    <div class="btns row flex-around">
      <button class=" col-5" @click="close(0)">放弃检查</button>
      <button class=" col-5 " @click="close(1)">不放弃</button>
    </div>
    <!--<div class="m-pop">-->
    <!--<div class="m-pop-box">-->
    <!--<div class="m-pop-cont">-->
    <!--<h5 class="m-pop-title">确认放弃“{{project.item}}”？</h5>-->

    <!--<div class="row row-align-center" v-show="project.star && project.star>0">-->
    <!--<div class="col-auto">-->
    <!--<i class="icon icon-tuijian assertive"></i>-->
    <!--<p>推荐等级</p>-->
    <!--</div>-->
    <!--<div class="col bewrite">-->
    <!--<div class="projectStar " :class="'star-'+ project.star"></div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="row row-align-center"  v-show=" project.star === 5 || project.counditionInfoList &&project.counditionInfoList.length">-->
    <!--<div class="col-auto">-->
    <!--<i class="icon icon-wentijiexi- assertive"></i>-->
    <!--<p>推荐理由</p>-->
    <!--</div>-->
    <!--<div class="col  bewrite"  v-show=" project.counditionInfoList &&project.counditionInfoList.length">该项检查与您的问题相关： <span v-for="(item,index) in project.counditionInfoList" class="counditionInfo assertive">{{item.name}} {{project.counditionInfoList.length-1 > index ? '、': ''}}</span></div>-->
    <!--<div class="col  bewrite"  v-show="project.star === 5  && (!project.counditionInfoList || !project.counditionInfoList.length)">该项目为当前年龄段基础必查项目</div>-->
    <!--</div>-->
    <!--<div class="row row-align-center">-->
    <!--<div class="col-auto">-->
    <!--<i class="icon icon-tingzhenqi assertive"></i>-->
    <!--<p>检查意义</p>-->
    <!--</div>-->
    <!--<div class="col bewrite">{{project.inspectionSignificance}}</div>-->
    <!--</div>-->
    <!--<div class="row btns">-->
    <!--<button class="col" @click="close(0)">放弃检查</button>-->
    <!--<button class="assertive col"  @click="close(1)">不放弃</button>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
  </van-popup>
</template>

<script>
import { Popup } from 'vant'
import Vue from 'vue'

Vue.use(Popup)
export default {
  name: 'deleteRecommend',
  data () {
    return {}
  },
  props: {
    //    disclaimer: {
    //      type: String,
    //      default: ''
    //    },
    project: {
      type: Object,
      default: {}
    },
    showModal: {
      type: Boolean,
      default: false
    }
    //    recordCode: {
    //      type: Boolean,
    //      default: false
    //    },
    //    showTxt: {
    //      type: String,
    //      default: ''
    //    }
  },
  computed: {
    openModal: {
      get: function () {
        return this.showModal
      },
      set: function (v) {
        return !this.showModal
      }
    }
  },

  methods: {
    //    close (index) {
    //      this.$emit('btnClose', this.notarizeState)
    //    },
    close (index) {
      this.$emit('btnClose', index, this.project)
    },
    maskClicked (e) {
      this.close(1)
    }
    //    lookExplain (e) {
    //      this.$emit('lookExplain')
    //    }
  }
}
</script>

<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";

  .van-popup {
    border-radius: 10px;
    padding-bottom: 50px;
  }

  .wrapper {
    width: 320px;
    /*max*/
    padding: 20px;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 30px;
    position: relative;
    span {
      font-weight: bold;
      font-size: 18px;
      &:before {
        content: ' ';
        display: block;
        position: absolute;
        bottom: 24px;
        width: 30px;
        border-bottom: 2px solid $assertive;
      }
    }
    .icon {
      font-size: 26px;
    }
  }

  .main-box {
    max-height: 400px;
    overflow-y: auto;
  }

  .item {
    padding-bottom: 18px;
    div {
      font-size: 14px;
      font-weight: bold;
      padding-bottom: 6px;
    }

    p {
      font-size: 14px;
    }
  }
.assertive{
  /*color: red !important;*/
}
  .btns {
    position: absolute;
    width: 100%;
    padding: 15px 0;
    background: $light;
    font-size: 14px;
    bottom: 0px;
    /*padding: 0;*/
    /*padding-top: 15px;*/
    button {
      background-color: $light;
      /*<!--border: 1px solid $assertive;-->*/
      /*border-bottom: none;*/
      padding: 5px 0;
      border-radius: 5px;
      &:first-child {
        border: 1px solid $assertive;
        color: $assertive;
      }
      &:last-child {
        color: $light;
        border: 1px solid $assertive;
        background-color: $assertive;
      }
    }
  }
</style>
